import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    query: {},
    profile: {},
  },
  mutations: {
  },
  actions: {
    messengerClose() {
      MessengerExtensions.requestCloseBrowser(
        function success() { },
        function error() {
          window.close();
        }
      );
    }
  },
  modules: {
  }
})
